export default "__VITE_ASSET__C9xEUY$D__"